var cache = {};
var tmpl = function(str, data){
    // Figure out if we're getting a template, or if we need to
    // load the template - and be sure to cache the result.
    var fn = !/\W/.test(str) ?
        cache[str] = cache[str] ||
        tmpl(document.getElementById(str).innerHTML) :
        
        // Generate a reusable function that will serve as a template
        // generator (and which will be cached).
        new Function("obj",
        "var p=[],print=function(){p.push.apply(p,arguments);};" +
            
        // Introduce the data as local variables using with(){}
        "with(obj){p.push('" +
            
        // Convert the template into pure JavaScript
        str
            .replace(/[\r\t\n]/g, " ")
            .split("<%").join("\t")
            .replace(/((^|%>)[^\t]*)'/g, "$1\r")
            .replace(/\t=(.*?)%>/g, "',$1,'")
            .split("\t").join("');")
            .split("%>").join("p.push('")
            .split("\r").join("\\'")
        + "');}return p.join('');");
        
    // Provide some basic currying to the user
    return data ? fn( data ) : fn;
};

(function(){
    
    function calculateMinPrice(prices) {

    }

    this.minimumprice = function modalMinimumPrice(data) {
        // Remove function
        var removeModal = function() {
            modalDom.remove();
            bodyDom.removeClass('has-modal');
        }

        // Adds class on body
        var bodyDom = $(document.body);
        bodyDom.addClass('has-modal');

        // Setup the modal window
        var modalDom = $(document.createElement('div'));
        modalDom.addClass('modal');

        // Setup the modal backdrop
        var modalBackdropDom = $(document.createElement('div'));
        modalBackdropDom.addClass('modal__backdrop');
        modalBackdropDom.appendTo(modalDom);
        modalBackdropDom.on('click', removeModal);

        // Setup the body
        var modalBodyDom = $(document.createElement('div'));
        modalBodyDom.addClass('modal__body');

        // Setup html
        var html = tmpl('minPriceModalContent', {
            key:                   data.key ||  null,
            binding:               data.binding ||  null,
            prices:                data.prices || [],
            subscription:          data.subscription || null,
            totalSubscription:     data.totalSubscription || null,
            totalSetup:            data.totalSetup ||  null,
            totalDelivery:         data.totalDelivery ||  null,
            minPrice:              data.minPrice ||  null,
            totalSetupDiscount:    Math.abs(data.totalSetupDiscount) || null,
            totalDeliveryDiscount: Math.abs(data.totalDeliveryDiscount) || null,
            subscriptionDiscount:  Math.abs(data.subscriptionDiscount) || null,
            totalDiscount:         Math.abs(data.totalDiscount) ||  null,
            campaignEnd:           data.campaignEnd || null
        });

        modalBodyDom.html(html);
        modalBodyDom.appendTo(modalDom);

        // Setup the body
        var modalCloseDom = $(document.createElement('button'));
        modalCloseDom.html('&times;');
        modalCloseDom.addClass('modal__close');
        modalCloseDom.appendTo(modalBodyDom);
        modalCloseDom.on('click', removeModal);

        // Add to dom
        bodyDom.append(modalDom);
    }

    var testMatches = location.search.match(/test=([0-9]{4}-[0-9]{2}-[0-9]{2})/i);

    var now = new Date();
    var newYear = new Date('2022-01-01T00:00:00');
    

    if(testMatches){
        now = new Date(testMatches[1] + 'T00:00:00');
    }

    now.setHours(0);
    now.setMinutes(0);
    now = now.getTime();

    if(now < newYear.getTime()){
        document.querySelector('#nkuAlert').style.display = 'flex';
        document.querySelector('#nkuLegalText').style.display = 'inline';
    }

    function activeCampaign(campaigns){
        if(!campaigns) return null;
        
        campaigns = campaigns.filter(function(c){
            var start = new Date(c.campaignStart);
            var end = new Date(c.campaignEnd);
            start.setHours(0);
            end.setHours(0);
            return start.getTime() <= now && end.getTime() >= now;
        });

        return campaigns.length ? campaigns[0] : null;
    }
    function formatDate(d){
        d = new Date(d);
        return d.getDate() + '/' + (d.getMonth() + 1) + ' ' + d.getFullYear();
    }
    function getJSON(url, name, success, error){
        var request = new XMLHttpRequest();
        request.open('GET', url, true);

        request.onload = function() {
            if (this.status >= 200 && this.status < 400){
                try {
                    success({
                        name: name,
                        data: JSON.parse(this.response)
                    });
                } catch(e){
                    error({
                        name: name,
                        data: this
                    });
                }
                
            } else {
                error({
                    name: name,
                    data: this
                });
            }
        };

        request.onerror = function(){
            error({
                name: name,
                data: this
            });
        };

        request.send();
    }

    var tpl = document.querySelector('#prodctTpl').innerHTML;
    var headerTpl = document.querySelector('#prodctTplHeader').innerHTML;
    var headerTplGP = document.querySelector('#prodctTplHeaderGP').innerHTML;
    var campaignLegalTextTpl = document.querySelector('#campaignLegalTextTpl').innerHTML;

    function renderPlaceholder(){
        var content = '';
        
        for(var i = 0; i <= 3; i++){
            content += tpl.replace(/\{i\}/g, i)
                        .replace('{header}', i ? headerTpl.replace('{points}', '0') : headerTplGP)
                        .replace('{setup}', 'Oprettelse')
                        .replace('{delivery}', 'Forsendelse')
                        .replace(/\{.+\}/g, '');
        }

        document.querySelector('.tvPackages-list').innerHTML = content;
    }

    function daysWithDiscount(priceLine) {
        if (!priceLine.startMonth && priceLine.endMonth) return;

        return priceLine.startMonth && priceLine.endMonth ? priceLine.endMonth > 1 ? priceLine.endMonth - (priceLine.startMonth - 1) : priceLine.endMonth : 1;
    }

    function renderProducts(products){
        products.sort(function(a, b){
            if(a.productCode < b.productCode) { return -1; }
            if(a.productCode > b.productCode) { return 1; }
            return 0;
        });

        var list = document.querySelector('.tvPackages-list');
        var minPrices = [];
        list.innerHTML = products.map(function(p, i){
            var campaign = activeCampaign(p.campaigns);
            var isBlandSelv = p.priceLines.filter(function(l){ return l.type === 'GP' }).length > 0;
            var recurring = p.priceLines.filter(function(l){
                return l.type !== 'CREATION' && l.type !== 'SHIPMENT';
            }).reduce(function(total, l){
                return total + parseInt(l.unitPrice);
            }, 0);

            var priceLines = p.priceLines.map(function(l){
                switch(l.type){
                    case 'GP':
                        l.title = 'Grundpakke';
                        break;
                    case 'RECURRING':
                        l.title = p.productName;
                        break;
                    case 'CREATION':
                        l.title = 'Oprettelse';
                        break;
                    case 'SHIPMENT':
                        l.title = 'Forsendelse';
                        break;
                }

                l.contract = l.startMonth && l.endMonth ? l.endMonth : 1;
                l.subtotal = l.contract * l.unitPrice;                

                if(campaign){
                    var override = campaign.priceLineOverrides.filter(function(campaignLine){
                        if (campaignLine.type === l.type) {                   
                            campaignLine.daysWithDiscount = daysWithDiscount(campaignLine);

                            return campaignLine;
                        };
                    });

                    if(override.length){
                        var dWD = daysWithDiscount(override[0]);
                        l.discount = (parseInt(override[0].unitPrice) - parseInt(override[0].actualPrice))*dWD;
                        l.daysWithDiscount = dWD;
                        l.amountRemaining = l.subtotal - l.discount;
                    } else {
                        l.discount = 0;
                        l.amountRemaining = l.subtotal
                    }
                } else {
                    l.discount = 0;
                    l.amountRemaining = l.subtotal
                }

                if (l.type === 'GP') {
                    l.type = 'RECURRING';
                }    

                return l;
            });
            
            var totalDiscount = campaign ? campaign.priceLineOverrides.reduce(function(total, l) {
                return total + (parseInt(l.unitPrice) - parseInt(l.actualPrice))*l.daysWithDiscount;
            }, 0) : 0;

            var setupCampaign = campaign ? campaign.priceLineOverrides.filter(function(l){
                return l.type === 'CREATION';
            }) : [];

            if(setupCampaign.length){
                var totalSetup = setupCampaign[0].actualPrice;
            } else {
                var totalSetup = p.priceLines.filter(function(l){
                    return l.type === 'CREATION';
                })[0].unitPrice;
            }

            var deliveryCampaign = campaign ? campaign.priceLineOverrides.filter(function(l){
                return l.type === 'SHIPMENT';
            }) : [];

            if(deliveryCampaign.length){
                var totalDelivery = deliveryCampaign[0].actualPrice;
            } else {
                var totalDelivery = p.priceLines.filter(function(l){
                    return l.type === 'SHIPMENT';
                })[0].unitPrice;
            }

            var price = {
                title: p.productName,
                prices: priceLines,
                contract: p.priceLines.reduce(function(highest, l){
                    var endMonth = l.endMonth ? parseInt(l.endMonth) : 0;
                    return highest < endMonth ? endMonth : highest;
                }, 0),
                totalSetup: totalSetup,
                totalDelivery: totalDelivery,
                totalDiscount: totalDiscount,
                totalDiscountRecurring: p.priceLines.reduce(function(total, l) {
                    return total + (l.type === 'RECURRING' ? parseInt((l.discount / l.daysWithDiscount)) : 0);
                }, 0),
                totalRecurring: p.priceLines.reduce(function(total, l) {
                    return total + (l.type === 'RECURRING' ? parseInt(l.unitPrice) : 0);
                }, 0),
                minPrice: p.priceLines.reduce(function(total, l){
                    return total + l.subtotal;
                }, 0) - totalDiscount,
                campaignEnd: campaign ? formatDate(campaign.campaignEnd) : null
            }

            minPrices.push(price);

            var campaignSplash = price.totalDiscount ? document.querySelector('#campaignSplash').innerHTML.replace('{savings}', price.totalDiscount) : '';

            return tpl.replace(/\{i\}/g, i)
                    .replace('{campaignSplash}', campaignSplash)
                    .replace('{recurring}', recurring)
                    .replace('{header}', isBlandSelv ? headerTpl.replace('{points}', p.productName.replace('Bland Selv ', '')) : headerTplGP)
                    .replace('{setup}', (price.totalDiscount ? '<b>' : '') + 'Oprettelse: ' + price.totalSetup + ',-' + (price.totalDiscount ? '</b>' : ''))
                    .replace('{totalDiscountRecurring}', ((price.totalDiscountRecurring > 0) ? '<b>Abonnement: ' + (price.totalRecurring-price.totalDiscountRecurring) + '</b>' : '&nbsp;'))
                    .replace('{delivery}', (price.totalDiscount ? '<b>' : '') + 'Forsendelse: ' + price.totalDelivery + ',-' + (price.totalDiscount ? '</b>' : ''))
                    .replace('{contractLength}', price.contract + ' md' + (price.contract > 1 ? 'r' : '') + '.')
                    .replace('{minPrice}', price.minPrice);
        }).join('');

        var campaignProducts = products.map(function(p){
            var active = activeCampaign(p.campaigns);
            return active ? { name: p.productName, campaign: active } : null;
        }).filter(function(p){
            return p;
        });

        campaignProduct = campaignProducts.length ? campaignProducts[0] : null;

        if(campaignProduct){
            document.querySelector('#campaignLegalText').innerHTML = campaignLegalTextTpl.replace('{campaignEnd}', formatDate(campaignProduct.campaign.campaignEnd))
                                                                                         .replace('{productName}', campaignProduct.name);
        }

        minPrices.forEach(function(minPrice, i){
            document.querySelector('.tvPackages-listItem-package' + i + ' .min-price-link').addEventListener('click', function(e){
                e.preventDefault();
                minimumprice(minPrice);
            });
        });
        
        list.className = 'tvPackages-list';
        document.querySelector('.tvPackages__footer-text').style.opacity = 1;
    }

    function error(res){
        if(res.name === 'products'){
            document.querySelector('.tvPackages-container').innerHTML = document.querySelector('#alertError').innerHTML;
        }
        
    }
    function done(res){
        if(res.name === 'address'){
            document.querySelector('#address').innerText = res.data.formattedAddress;
            document.querySelector('.address').style.opacity = 1;
        } else {
            renderProducts(res.data);
        }
    }

    var addressIDMatches = location.search.match(/addressID=([a-z0-9]{32})/i);

    if(!addressIDMatches){
        error();
    } else {
        var addressID = addressIDMatches[1];
        
        getJSON('https://t25-odinapi.internal.yousee.dk/yousee/sales/pdsmdialog/autocomplete/address?madID=' + addressID, 'address', done, error);
        getJSON('/static/dsl-tv-products.json', 'products', done, error);
    }
})();
